import React, { FC } from "react";
import { createUseStyles, useTheme } from "react-jss";
import styles from "./styles";

interface Props {
  currentView: string;
  changeView: (view: string) => void;
  searchbarOption: string;
  handleKeyDown: (event: React.KeyboardEvent, view: string) => void;
}

const MapSwitcher: FC<Props> = (props: Props) => {
  const useStyles = createUseStyles(styles);
  const theme = useTheme();

  const classes = useStyles({
    theme,
    ...props,
  });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { currentView, changeView, searchbarOption } = props;

  return (
    <div className={classes.container} data-testid="mapswitcher">
      <div
        className={classes.campusMap}
        onClick={() => changeView("campusmap")}
        onKeyDown={(event) => props.handleKeyDown(event, "campusmap")}
        role="button"
        tabIndex={0}
        data-testid="campusmap"
      >
        Campus Map
      </div>
      <div
        className={classes.mapView}
        onClick={() => changeView("mapview")}
        onKeyDown={(event) => props.handleKeyDown(event, "mapview")}
        role="button"
        tabIndex={0}
        data-testid="mapview"
      >
        Google Map
      </div>
    </div>
  );
};

export default MapSwitcher;
try {
    // @ts-ignore
    MapSwitcher.displayName = "MapSwitcher";
    // @ts-ignore
    MapSwitcher.__docgenInfo = { "description": "", "displayName": "MapSwitcher", "props": { "currentView": { "defaultValue": null, "description": "", "name": "currentView", "required": true, "type": { "name": "string" } }, "changeView": { "defaultValue": null, "description": "", "name": "changeView", "required": true, "type": { "name": "(view: string) => void" } }, "searchbarOption": { "defaultValue": null, "description": "", "name": "searchbarOption", "required": true, "type": { "name": "string" } }, "handleKeyDown": { "defaultValue": null, "description": "", "name": "handleKeyDown", "required": true, "type": { "name": "(event: any, view: string) => void" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/MapSwitcher/MapSwitcher.tsx#MapSwitcher"] = { docgenInfo: MapSwitcher.__docgenInfo, name: "MapSwitcher", path: "src/shared/components/MapSwitcher/MapSwitcher.tsx#MapSwitcher" };
}
catch (__react_docgen_typescript_loader_error) { }